module.exports = __webpack_public_path__ + "img/ahn-logo.4e3f6d7f.svg";